import { render, staticRenderFns } from "./modern-contemporary-4.vue?vue&type=template&id=77b1309a"
import script from "./modern-contemporary-4.vue?vue&type=script&lang=js"
export * from "./modern-contemporary-4.vue?vue&type=script&lang=js"
import style0 from "./modern-contemporary-4.vue?vue&type=style&index=0&id=77b1309a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports